import { ESuggestType, ICitySuggest } from '../../../types/suggest';

export const POPULAR_CITIES: ICitySuggest[] = [
  {
    id: 1,
    displayName: 'Москва',
    type: ESuggestType.city,
    value: 'Москва',
  },
  {
    id: 2,
    displayName: 'Санкт-Петербург',
    type: ESuggestType.city,
    value: 'Санкт-Петербург',
  },
  {
    id: 4777,
    regionId: 4618,
    displayName: 'Казань',
    type: ESuggestType.city,
    value: 'Казань',
  },
  {
    id: 4914,
    regionId: 4599,
    displayName: 'Омск',
    type: ESuggestType.city,
    value: 'Омск',
  },
];
